export default __webpack_public_path__ + "static/media/personIcon.c0b6b605.svg";